module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "header-wrapper pagedetail animate fadeIn"
  }, [_c('h1', {
    staticClass: "pagedetail__title text-center"
  }, [_vm._v("สร้างกองผ้าป่า")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 pd-sm-0"
  }, [_c('page-card', {
    ref: "card",
    attrs: {
      "title": _vm.form.title,
      "message": _vm.form.message,
      "province": _vm.form.provinceObject,
      "school": _vm.form.schoolObject,
      "owner": _vm.form.owner,
      "editing": _vm.editing
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.showRegisterForm) ? _c('div', {
    staticClass: "block-border radius block shadow"
  }, [_c('page-form', {
    attrs: {
      "disabled": _vm.submitting,
      "submit-button-text": _vm.submitButtonText
    },
    on: {
      "submit": _vm.submit
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showRegisterForm) ? _c('div', {
    staticClass: "block-border radius block shadow"
  }, [_c('page-register-form', {
    on: {
      "submit": _vm.registered,
      "cancel": function($event) {
        _vm.showRegisterForm = false
      }
    }
  })], 1) : _vm._e()])], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "text-center text-white"
  }, [_vm._v("กองผ้าป่าที่คุณสร้างนั้น สำหรับเงินบริจาคที่ได้มาทั้งหมด ทางโครงการจะนำมอบเป็นทุนให้กับเด็กและโรงเรียนในโครงการร้อยพลังการศึกษา")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb78241a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/pages/phapa/create.vue
// module id = 1201
// module chunks = 1